import type { DocumentData } from '../components/DocumentPage/DocumentContext';

/**
 * This function defines the logic of whether to load ads or not,
 * regardless of layout restrictions
 */
export const shouldShowAds = ({
    context: {
        document: { contentRating },
        publisher: {
            licenses: { hideAdsInReader, docpageAds },
        },
        crawler,
    },
    ignoreLicense = false,
}: {
    context: DocumentData;
    ignoreLicense?: boolean;
}): boolean => {
    if (
        // if page is indexed by bots
        crawler ||
        // if isAdsafe is false
        (contentRating.isReviewed && !contentRating.isAdsafe) ||
        // or if paid publisher without docpageAds (unless ignored)
        (!ignoreLicense && hideAdsInReader && !docpageAds)
    ) {
        return false;
    }

    return true;
};

export const maxSize = (sizes: googletag.MultiSize): [number, number] =>
    [0, 1].map(n =>
        Math.max(
            ...sizes.map(s => {
                const sizeUnit = s[n];
                return typeof sizeUnit === 'number' ? sizeUnit : 1;
            }),
        ),
    ) as [number, number];
